import React from 'react';
import { Route } from 'react-router-dom';
import UsersOverviewPage from '../../UserDashboard/admin/UsersOverviewPage';
import UserDashboardLayout from '../../UserDashboard/UserDashboardLayout';
import OverviewPage from '../../UserDashboard/OverviewPage';
import OperationsPage from '../../UserDashboard/OperationsPage';
import RoomsPage from '../../UserDashboard/RoomsPage';
import EfficacyPage from '../../UserDashboard/EfficacyPage';
import SubscriptionPage from '../../UserDashboard/SubscriptionPage';
import { guardRoute } from '../ProtectedRoute';

export const adminUserDashboardRoutes = [
  <Route
    key="admin-users"
    path="/admin/users"
    element={guardRoute(<UsersOverviewPage />, '/admin/users')}
  />,
  <Route
    key="admin-user-dashboard"
    path="/admin/users/:email"
    element={guardRoute(<UserDashboardLayout adminView />, '/admin/users')}
  >
    <Route index element={<OverviewPage />} />
    <Route path="overview" element={<OverviewPage />} />
    <Route path="operations" element={<OperationsPage />} />
    <Route path="rooms" element={<RoomsPage />} />
    <Route path="efficacy" element={<EfficacyPage />} />
    <Route path="subscription" element={<SubscriptionPage />} />
  </Route>,
];
